import { registerLocaleData } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { register } from 'swiper/element/bundle';

registerLocaleData(localePtBr, 'pt-BR');
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
// Sobrescreve os console.log em produção
if (environment.production) {
  enableProdMode();

  const noop = (): void => undefined;

  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;

  // console.error = noop;
}
register();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
